(function ($) {
  $(function () {

    var scrollToTopButton = document.querySelector('[data-scroll-to-top]');

    if (scrollToTopButton) { 
      var updateScrollToTop = function () {
        scrollToTopButton.hidden = window.scrollY <= 320;
      };

      window.addEventListener('scroll', updateScrollToTop, { passive: true });
      window.addEventListener('pageshow', updateScrollToTop);
      updateScrollToTop();

      scrollToTopButton.addEventListener('click', function () {
        var pageTop = document.getElementById('page');
 
        if (pageTop) {
          var hadTabIndex = pageTop.hasAttribute('tabindex');

          if (!hadTabIndex) {
            pageTop.setAttribute('tabindex', '-1');
          }

          pageTop.focus({ preventScroll: true });

          if (!hadTabIndex) {
            pageTop.removeAttribute('tabindex');
          }
        }

        window.scrollTo({
          top: 0,
          behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'
        });
      });
    }


    $('.nav-button').on('click', function (e) {
      e.preventDefault();
      $(this).toggleClass('active');
      $('.navigation-floating').toggleClass('opened');
      $('.overlay-black').addClass('active');

    });

    $('.nav-button.active').on('click', function () {
      $(this).removeClass('active');
      $('.navigation-floating.opened').removeClass('opened');
    });

    /*  
     * Header search panel
     */ 
    var headerSearchToggles = Array.prototype.slice.call(document.querySelectorAll('[data-header-search-toggle]'));
    var headerSearchPanel = document.querySelector('[data-header-search-panel]');
	var themeToggles = Array.prototype.slice.call(document.querySelectorAll('[data-theme-toggle]'));

	if (themeToggles.length) {
	  var applyTheme = function (theme, persist) {
		var isDark = theme === 'dark';

		document.documentElement.setAttribute('data-theme', isDark ? 'dark' : 'light');
		document.documentElement.style.colorScheme = isDark ? 'dark' : 'light';

		themeToggles.forEach(function (themeToggle) {
		  var themeIcon = themeToggle.querySelector('[data-theme-toggle-icon]');

		  themeToggle.setAttribute('aria-pressed', isDark ? 'true' : 'false');
		  themeToggle.setAttribute(
			'aria-label',
			isDark
			  ? (themeToggle.getAttribute('data-theme-light-label') || 'Пређи на светлу тему')
			  : (themeToggle.getAttribute('data-theme-dark-label') || 'Пређи на тамну тему')
		  );

		  if (themeIcon) {
			themeIcon.classList.toggle('icon-moon', !isDark);
			themeIcon.classList.toggle('icon-sun', isDark);
		  }
		});

		if (persist) {
		  try {
			window.localStorage.setItem('dd-theme-mode', isDark ? 'dark' : 'light');
		  } catch (error) {
			// The theme still works when browser storage is unavailable.
		  }
		}
	  };

	  applyTheme(document.documentElement.getAttribute('data-theme') || 'light', false);

	  themeToggles.forEach(function (themeToggle) {
		themeToggle.addEventListener('click', function () {
		  applyTheme(document.documentElement.getAttribute('data-theme') === 'dark' ? 'light' : 'dark', true);
		});
	  });

	  window.addEventListener('storage', function (event) {
		if (event.key === 'dd-theme-mode' && (event.newValue === 'light' || event.newValue === 'dark')) {
		  applyTheme(event.newValue, false);
		}
	  });
	}

    if (headerSearchToggles.length && headerSearchPanel) {
      var headerSearchInput = headerSearchPanel.querySelector('.search-form__field');
      var lastHeaderSearchToggle = headerSearchToggles[0];

      var updateHeaderSearchToggles = function (isOpen) {
        headerSearchToggles.forEach(function (headerSearchToggle) {
          headerSearchToggle.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
          headerSearchToggle.classList.toggle('is-open', isOpen);
        });
      };

      var closeHeaderSearch = function () {
        headerSearchPanel.hidden = true;
        updateHeaderSearchToggles(false);
      };

      var openHeaderSearch = function () {
        if (typeof closeMobileMenu === 'function') {
          closeMobileMenu(false);
        }

        headerSearchPanel.hidden = false;
        updateHeaderSearchToggles(true);

        if (headerSearchInput) {
          window.setTimeout(function () {
            headerSearchInput.focus();
          }, 30);
        }
      };

      headerSearchToggles.forEach(function (headerSearchToggle) {
        headerSearchToggle.addEventListener('click', function (event) {
          event.preventDefault();
          lastHeaderSearchToggle = headerSearchToggle;

          if (headerSearchPanel.hidden) {
            openHeaderSearch();
          } else {
            closeHeaderSearch();
          }
        });
      });

      document.addEventListener('click', function (event) {
        var clickedSearchToggle = headerSearchToggles.some(function (headerSearchToggle) {
          return headerSearchToggle.contains(event.target);
        });

        if (!headerSearchPanel.hidden && !headerSearchPanel.contains(event.target) && !clickedSearchToggle) {
          closeHeaderSearch();
        }
      });

      document.addEventListener('keydown', function (event) {
        if (event.key === 'Escape' && !headerSearchPanel.hidden) {
          closeHeaderSearch();
          lastHeaderSearchToggle.focus();
        }
      });
    }

    /*
     * Filter document lists, table body rows and staff cards on the current page.
     */
    var pageDocumentSearches = Array.prototype.slice.call(
      document.querySelectorAll('[data-page-document-search]')
    );
    var pageDocumentItems = Array.prototype.slice.call(
      document.querySelectorAll('[data-document-item]')
    );

    if (pageDocumentSearches.length) {
      var pageTableRows = Array.prototype.slice.call(
        document.querySelectorAll('#page table > tbody > tr')
      ).filter(function (row) {
        return Array.prototype.some.call(row.cells, function (cell) {
          return cell.tagName === 'TD';
        });
      });
      var pageStaffItems = Array.prototype.slice.call(
        document.querySelectorAll('[data-page-search-staff]')
      );
      var pageSearchItems = pageDocumentItems.concat(pageTableRows, pageStaffItems);

      pageTableRows.forEach(function (row) {
        row.setAttribute('data-page-search-row', '');
      });

      var normalizeDocumentSearchText = function (value) {
        var normalizedValue = (value || '').toString().toLocaleLowerCase('sr');
        var cyrillicToLatin = {
          'љ': 'lj', 'њ': 'nj', 'џ': 'dz', 'а': 'a', 'б': 'b', 'в': 'v',
          'г': 'g', 'д': 'd', 'ђ': 'dj', 'е': 'e', 'ж': 'z', 'з': 'z',
          'и': 'i', 'ј': 'j', 'к': 'k', 'л': 'l', 'м': 'm', 'н': 'n',
          'о': 'o', 'п': 'p', 'р': 'r', 'с': 's', 'т': 't', 'ћ': 'c',
          'у': 'u', 'ф': 'f', 'х': 'h', 'ц': 'c', 'ч': 'c', 'ш': 's'
        };

        normalizedValue = normalizedValue.replace(
          /[љњџабвгдђежзијклмнопрстћуфхцчш]/g,
          function (character) {
            return cyrillicToLatin[character] || character;
          }
        );

        if (normalizedValue.normalize) {
          normalizedValue = normalizedValue.normalize('NFD').replace(/[\u0300-\u036f]/g, '');
        }

        return normalizedValue.replace(/đ/g, 'dj').replace(/\s+/g, ' ').trim();
      };

      var updateDocumentGroupLabels = function (hasQuery) {
        document.querySelectorAll('[data-document-list]').forEach(function (documentList) {
          var groupLabels = Array.prototype.slice.call(
            documentList.querySelectorAll('[data-document-group-label]')
          );

          groupLabels.forEach(function (groupLabel) {
            var sibling = groupLabel.nextElementSibling;
            var hasVisibleDocument = false;

            while (sibling && !sibling.matches('[data-document-group-label]')) {
              if (sibling.matches('[data-document-item]') && !sibling.hidden) {
                hasVisibleDocument = true;
                break;
              }

              sibling = sibling.nextElementSibling;
            }

            groupLabel.hidden = hasQuery && !hasVisibleDocument;
          });
        });
      };

      var filterPageDocuments = function (searchValue, searchRoot) {
        var query = normalizeDocumentSearchText(searchValue);
        var hasQuery = query.length > 0;
        var visibleCount = 0;

        pageSearchItems.forEach(function (documentItem) {
          var searchText = documentItem.hasAttribute('data-page-search-row')
            ? Array.prototype.map.call(documentItem.cells, function (cell) { return cell.textContent; }).join(' ')
            : (documentItem.getAttribute('data-document-search-text') || documentItem.textContent);
          var isVisible = !hasQuery || normalizeDocumentSearchText(searchText).indexOf(query) !== -1;

          documentItem.hidden = !isVisible;

          if (isVisible) {
            visibleCount += 1;
          }
        });

        updateDocumentGroupLabels(hasQuery);

        document.querySelectorAll('[data-page-search-staff-list]').forEach(function (staffList) {
          var hasVisibleStaff = Array.prototype.some.call(
            staffList.querySelectorAll('[data-page-search-staff]'),
            function (staffItem) { return !staffItem.hidden; }
          );
          var heading = staffList.previousElementSibling;

          staffList.hidden = hasQuery && !hasVisibleStaff;

          if (heading && heading.hasAttribute('data-page-search-staff-heading')) {
            heading.hidden = staffList.hidden;
          }
        });

        document.querySelectorAll('[data-document-list-block]').forEach(function (documentBlock) {
          var blockItems = Array.prototype.slice.call(
            documentBlock.querySelectorAll('[data-document-item]')
          );
          var hasVisibleItem = blockItems.some(function (documentItem) {
            return !documentItem.hidden;
          });

          documentBlock.hidden = hasQuery && !hasVisibleItem;
        });

        var clearButton = searchRoot.querySelector('[data-page-document-search-clear]');
        var status = searchRoot.querySelector('[data-page-document-search-status]');

        if (clearButton) {
          clearButton.hidden = !hasQuery;
        }

        if (status) {
          if (!hasQuery) {
            status.textContent = '';
          } else if (visibleCount) {
            status.textContent = (pageTableRows.length || pageStaffItems.length ? 'Пронађено резултата: ' : 'Пронађено докумената: ') + visibleCount + '.';
          } else {
            status.textContent = pageTableRows.length || pageStaffItems.length
              ? 'Нема резултата који одговарају претрази.'
              : 'Нема докумената који одговарају претрази.';
          }
        }
      };

      pageDocumentSearches.forEach(function (searchRoot) {
        var searchInput = searchRoot.querySelector('[data-page-document-search-input]');
        var clearButton = searchRoot.querySelector('[data-page-document-search-clear]');

        if (!searchInput) {
          return;
        }

        if (!pageSearchItems.length) {
          searchRoot.hidden = true;
          return;
        }

        var searchLabel = searchRoot.querySelector('.page-document-search__label');

        if (searchLabel && pageStaffItems.length) {
          searchLabel.textContent = pageDocumentItems.length || pageTableRows.length
            ? searchLabel.getAttribute('data-search-content-label')
            : searchLabel.getAttribute('data-search-staff-label');
        } else if (searchLabel && pageTableRows.length) {
          searchLabel.textContent = pageDocumentItems.length
            ? searchLabel.getAttribute('data-search-mixed-label')
            : searchLabel.getAttribute('data-search-table-label');
        }

        searchInput.addEventListener('input', function () {
          filterPageDocuments(searchInput.value, searchRoot);
        });

        if (clearButton) {
          clearButton.addEventListener('click', function () {
            searchInput.value = '';
            filterPageDocuments('', searchRoot);
            searchInput.focus();
          });
        }

        searchInput.addEventListener('keydown', function (event) {
          if (event.key === 'Escape' && searchInput.value) {
            searchInput.value = '';
            filterPageDocuments('', searchRoot);
          }
        });

        searchRoot.hidden = false;
        filterPageDocuments(searchInput.value, searchRoot);
      });
    }

    /*
     * Contact OpenStreetMap.
     */
    var contactMaps = document.querySelectorAll('[data-contact-map]');

    if (contactMaps.length && typeof window.L !== 'undefined') {
      contactMaps.forEach(function (mapElement) {
        var latitude = parseFloat(mapElement.getAttribute('data-latitude'));
        var longitude = parseFloat(mapElement.getAttribute('data-longitude'));
        var zoom = parseInt(mapElement.getAttribute('data-zoom'), 10) || 14;

        if (!Number.isFinite(latitude) || !Number.isFinite(longitude)) {
          return;
        }

        var contactMap = window.L.map(mapElement, {
          zoomControl: false
        }).setView([latitude, longitude], zoom);

        contactMap.attributionControl.setPrefix(false);

        window.L.tileLayer('https://tile.openstreetmap.org/{z}/{x}/{y}.png', {
          maxZoom: 19,
          attribution: '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
        }).addTo(contactMap);

        window.L.control.zoom({
          position: 'topright'
        }).addTo(contactMap);

        var contactMarker = window.L.divIcon({
          className: 'contact-page__map-marker',
          html: '<svg viewBox="0 0 32 44" aria-hidden="true" focusable="false"><path d="M16 0C7.16 0 0 7.16 0 16c0 12 16 28 16 28s16-16 16-28C32 7.16 24.84 0 16 0z"></path><circle cx="16" cy="16" r="6"></circle></svg>',
          iconSize: [32, 48],
          iconAnchor: [16, 48]
        });

        window.L.marker([latitude, longitude], {
          icon: contactMarker,
          keyboard: false
        }).addTo(contactMap);
      });
    }

    /*
     * Fixed navbar and the mobile WordPress admin bar offset.
     * The WP toolbar scrolls out of view below 783px, so its live bottom
     * position is used instead of leaving a permanent 46px header gap.
     */
    var siteHeader = document.querySelector('.site-header');
    var wpAdminBar = document.getElementById('wpadminbar');
    var headerPositionFrame = null;

    var updateHeaderPosition = function () {
      headerPositionFrame = null;

      if (!siteHeader) {
        return;
      }

      var scrollTop = window.pageYOffset || document.documentElement.scrollTop || 0;
      var usesMobileAdminBar = document.body.classList.contains('admin-bar') && window.innerWidth <= 782;

      siteHeader.classList.toggle('navbar-fixed-top', scrollTop > 1);

      if (usesMobileAdminBar && wpAdminBar) {
        var adminBarOffset = Math.max(0, wpAdminBar.getBoundingClientRect().bottom);
        document.documentElement.style.setProperty('--wp-mobile-admin-bar-offset', adminBarOffset + 'px');
      } else {
        document.documentElement.style.removeProperty('--wp-mobile-admin-bar-offset');
      }
    };

    var requestHeaderPositionUpdate = function () {
      if (headerPositionFrame === null) {
        headerPositionFrame = window.requestAnimationFrame(updateHeaderPosition);
      }
    };

    window.addEventListener('scroll', requestHeaderPositionUpdate, { passive: true });
    window.addEventListener('resize', requestHeaderPositionUpdate);
    window.addEventListener('orientationchange', requestHeaderPositionUpdate);
    updateHeaderPosition();
 
    /* 
     * Owl carousel
     */
    $('.owl-room-card').owlCarousel({
      margin: 40,
      items: 3,
      loop: true,
      autoplay: true,
      autoplayTimeout: 4500,
      nav: true,
      dots: false,
      animateOut: 'fadeOut',
      navText: ["<i class='icon-angle-left'></i>", "<i class='icon-angle-right'></i>"],
      // navContainer: '#customNav',
      responsive: {
        0: {
          items: 1
        },
        700: {
          items: 2,
          margin: 0,
        },
        1200: {
          items: 3,
        }
      }
    });

    /*
     * Video modal 
     */
    $("body").on("click", "#play-video-modal", function (e) {
      e.preventDefault();
      $("#video-modal").modal("show");
      $("#video-modal iframe")[0].src += "?autoplay=1";
    });

    $("#video-modal").on('hidden.bs.modal', function (e) {
      var videoUrl = $("#video-modal iframe")[0].src;
      videoUrl = videoUrl.replace("?autoplay=1", "");
      $("#video-modal iframe")[0].src = videoUrl;
    });

    /*
     * Youtube lazy loading
     */
    $('#play-video-btn').on('click', function (e) {
      e.preventDefault();
      $('#youtubeModal').modal('show');
    });

    $("#youtubeModal").on('hidden.bs.modal', function (e) {
      $("#youtubeModal iframe").attr("src", $("#youtubeModal iframe").attr("src"));
    });
    /*
     * Lightbox gallery
     */
    var lightGalleryOptions = {
      selector: '.gallery-item',
      share: true,
      download: true,
      rotate: false,
      showThumbByDefault: true,
      loop: false,
      slideEndAnimatoin: false,
      thumbnail: true,
      allowMediaOverlap: true,
      toggleThumb: true,
      youtubePlayerParams: {
        loadYoutubeThumbnail: true,
        youtubeThumbSize: 'default',
        modestbranding: 1,
        showinfo: 0,
        rel: 0
      }
    };

    $('.gallery-images').lightGallery(lightGalleryOptions);

    if ($('figure.gallery-item > a[href]').length && $('#page').length) {
      $('#page').lightGallery($.extend({}, lightGalleryOptions, {
        selector: 'figure.gallery-item > a[href]'
      }));
    }

    /*
     * Sticky section menu from page headings
     */
    var stickyMenuSection = document.querySelector('[data-sticky-menu-section]');
    var stickyMenuList = document.querySelector('[data-sticky-menu-list]');
    var stickyMenuShell = document.querySelector('[data-sticky-menu-shell]');
    var stickyMenuScroll = document.querySelector('[data-sticky-menu-scroll]');
    var stickyMenuPrev = document.querySelector('[data-sticky-menu-prev]');
    var stickyMenuNext = document.querySelector('[data-sticky-menu-next]');

      if (stickyMenuSection && stickyMenuList) {
	      var contentRoot = document.querySelector('[data-sticky-menu-root]') || document.querySelector('#page');

      if (contentRoot) {
        var usedIds = {};
        var stickyMenuLinks = [];
        var pendingStickyTargetId = null;
        var pendingStickyTargetTimer = null;
        var activeStickyLinkId = null;
        // Use the same tolerance for scroll completion and fractional heading positions.
        var stickyScrollTolerance = 2;
        var headingSelector = 'h2';
        var headings = Array.prototype.slice.call(contentRoot.querySelectorAll(headingSelector)).filter(function (heading) {
          return heading.textContent.trim().length > 0;
        });

        var createSlug = function (value) {
          return value
            .toString()
            .trim()
            .replace(/[\u0110\u0111]/g, 'dj')
            .toLowerCase()
            .normalize('NFD')
            .replace(/[\u0300-\u036f]/g, '')
            .replace(/[^a-z0-9]+/g, '-')
            .replace(/^-+|-+$/g, '') || 'section';
        };

        var ensureUniqueId = function (baseId) {
          var uniqueId = baseId;
          var counter = 2;

          while (usedIds[uniqueId] || document.getElementById(uniqueId)) {
            uniqueId = baseId + '-' + counter;
            counter += 1;
          }

          usedIds[uniqueId] = true;

          return uniqueId;
        };

        headings.forEach(function (heading) {
          var headingText = heading.textContent.trim();
          var baseId = heading.id ? heading.id.trim() : createSlug(headingText);
          var existingElement = baseId ? document.getElementById(baseId) : null;
          var hasValidExistingId = baseId && !usedIds[baseId] && (!existingElement || existingElement === heading);
          var headingId = hasValidExistingId ? baseId : ensureUniqueId(createSlug(headingText));

          if (hasValidExistingId) {
            usedIds[headingId] = true;
          }

          if (!heading.id || heading.id !== headingId) {
            heading.id = headingId;
          }

          heading.classList.add('sticky-section-anchor');

          var menuItem = document.createElement('li');
          menuItem.className = 'sticky-section-menu__item';

          var menuLink = document.createElement('a');
          menuLink.className = 'sticky-section-menu__link';
          menuLink.href = '#' + headingId;
          menuLink.textContent = headingText;

          stickyMenuLinks.push({
            id: headingId,
            link: menuLink
          });

          menuItem.appendChild(menuLink);
          stickyMenuList.appendChild(menuItem);
        });

        var updateStickyMenuOverflow = function () {
          if (!stickyMenuShell || !stickyMenuScroll) {
            return;
          }

          var maxScrollLeft = Math.max(stickyMenuScroll.scrollWidth - stickyMenuScroll.clientWidth, 0);
          var hasOverflow = maxScrollLeft > 2;
          var canScrollLeft = hasOverflow && stickyMenuScroll.scrollLeft > 2;
          var canScrollRight = hasOverflow && stickyMenuScroll.scrollLeft < maxScrollLeft - 2;

          stickyMenuShell.classList.toggle('has-overflow', hasOverflow);
          stickyMenuShell.classList.toggle('can-scroll-left', canScrollLeft);
          stickyMenuShell.classList.toggle('can-scroll-right', canScrollRight);

          if (stickyMenuPrev) {
            stickyMenuPrev.disabled = !canScrollLeft;
            stickyMenuPrev.setAttribute('aria-hidden', canScrollLeft ? 'false' : 'true');
          }

          if (stickyMenuNext) {
            stickyMenuNext.disabled = !canScrollRight;
            stickyMenuNext.setAttribute('aria-hidden', canScrollRight ? 'false' : 'true');
          }
        };

        var revealStickyMenuLink = function (menuLink) {
          if (!stickyMenuScroll || !menuLink) {
            return;
          }

          var controlSpace = 50;
          var visibleStart = stickyMenuScroll.scrollLeft + controlSpace;
          var visibleEnd = stickyMenuScroll.scrollLeft + stickyMenuScroll.clientWidth - controlSpace;
          var linkStart = menuLink.offsetLeft;
          var linkEnd = linkStart + menuLink.offsetWidth;
          var targetScrollLeft = stickyMenuScroll.scrollLeft;

          if (linkStart < visibleStart) {
            targetScrollLeft = Math.max(linkStart - controlSpace, 0);
          } else if (linkEnd > visibleEnd) {
            targetScrollLeft = linkEnd - stickyMenuScroll.clientWidth + controlSpace;
          }

          if (Math.abs(targetScrollLeft - stickyMenuScroll.scrollLeft) > 2) {
            stickyMenuScroll.scrollTo({
              left: targetScrollLeft,
              behavior: 'smooth'
            });
          }
        };

        var setActiveStickyLink = function (activeId) {
          stickyMenuLinks.forEach(function (menuEntry) {
            menuEntry.link.classList.toggle('is-active', menuEntry.id === activeId);
          });

          if (activeStickyLinkId !== activeId) {
            activeStickyLinkId = activeId;

            stickyMenuLinks.some(function (menuEntry) {
              if (menuEntry.id === activeId) {
                revealStickyMenuLink(menuEntry.link);
                return true;
              }

              return false;
            });
          }
        };

        var getStickyMenuOffset = function () {
          var siteHeader = document.querySelector('.site-header');
          var adminBar = document.querySelector('#wpadminbar');
          var siteHeaderHeight = siteHeader ? siteHeader.offsetHeight : 0;
          var adminBarHeight = adminBar ? adminBar.offsetHeight : 0;
          var stickyMenuHeight = stickyMenuSection ? stickyMenuSection.offsetHeight : 0;

          return adminBarHeight + siteHeaderHeight + stickyMenuHeight + 28;
        };

        var getHeadingDocumentTop = function (heading) {
          var rect = heading.getBoundingClientRect();

          return rect.top + window.pageYOffset;
        };

        var scrollToStickyHeading = function (heading) {
          if (!heading) {
            return;
          }

          var targetTop = Math.max(getHeadingDocumentTop(heading) - getStickyMenuOffset(), 0);

          window.scrollTo({
            top: targetTop,
            behavior: 'smooth'
          });
        };

        var updateStickyMenuActiveState = function () {
          if (!headings.length || !stickyMenuLinks.length) {
            return;
          }

          if (pendingStickyTargetId) {
            var pendingHeading = document.getElementById(pendingStickyTargetId);
            var pendingTargetTop = pendingHeading ? Math.max(getHeadingDocumentTop(pendingHeading) - getStickyMenuOffset(), 0) : null;

            if (pendingTargetTop !== null && Math.abs(window.pageYOffset - pendingTargetTop) <= stickyScrollTolerance) {
              pendingStickyTargetId = null;

              if (pendingStickyTargetTimer) {
                window.clearTimeout(pendingStickyTargetTimer);
                pendingStickyTargetTimer = null;
              }
            } else {
              setActiveStickyLink(pendingStickyTargetId);
              return;
            }
          }

          var scrollPosition = window.pageYOffset + getStickyMenuOffset();
          var activeHeadingId = headings[0].id;

          headings.forEach(function (heading) {
            if (scrollPosition + stickyScrollTolerance >= getHeadingDocumentTop(heading)) {
              activeHeadingId = heading.id;
            }
          });

          setActiveStickyLink(activeHeadingId);
        };

        stickyMenuLinks.forEach(function (menuEntry) {
          menuEntry.link.addEventListener('click', function (event) {
            var targetHeading = document.getElementById(menuEntry.id);

            event.preventDefault();
            pendingStickyTargetId = menuEntry.id;

            if (pendingStickyTargetTimer) {
              window.clearTimeout(pendingStickyTargetTimer);
            }

            pendingStickyTargetTimer = window.setTimeout(function () {
              pendingStickyTargetId = null;
              pendingStickyTargetTimer = null;
              updateStickyMenuActiveState();
            }, 1400);

            setActiveStickyLink(menuEntry.id);

            if (targetHeading) {
              if (window.history && window.history.pushState) {
                window.history.pushState(null, '', '#' + menuEntry.id);
              } else {
                window.location.hash = menuEntry.id;
              }

              scrollToStickyHeading(targetHeading);
            }
          });
        });

        if (headings.length) {
          stickyMenuSection.hidden = false;
          updateStickyMenuOverflow();
          updateStickyMenuActiveState();

          if (stickyMenuScroll) {
            stickyMenuScroll.addEventListener('scroll', updateStickyMenuOverflow, { passive: true });
          }

          if (stickyMenuPrev) {
            stickyMenuPrev.addEventListener('click', function () {
              stickyMenuScroll.scrollBy({
                left: -Math.max(stickyMenuScroll.clientWidth * 0.7, 240),
                behavior: 'smooth'
              });
            });
          }

          if (stickyMenuNext) {
            stickyMenuNext.addEventListener('click', function () {
              stickyMenuScroll.scrollBy({
                left: Math.max(stickyMenuScroll.clientWidth * 0.7, 240),
                behavior: 'smooth'
              });
            });
          }

          if (window.location.hash) {
            var hashTarget = document.getElementById(window.location.hash.substring(1));

            if (hashTarget) {
              setTimeout(function () {
                scrollToStickyHeading(hashTarget);
                updateStickyMenuActiveState();
              }, 50);
            }
          }

          window.addEventListener('scroll', updateStickyMenuActiveState, { passive: true });
          window.addEventListener('resize', function () {
            updateStickyMenuOverflow();
            updateStickyMenuActiveState();
          });
          window.addEventListener('hashchange', updateStickyMenuActiveState);

          if (document.fonts && document.fonts.ready) {
            document.fonts.ready.then(updateStickyMenuOverflow);
          }
        }
      }
    }

    /*
     * Desktop menu parents only control their dropdowns. Their URLs remain
     * available to the custom mobile menu as overview links.
     */
    var desktopMenuParentLinks = Array.prototype.slice.call(
      document.querySelectorAll('.site-header .navbar-collapse .menu-item-has-children > a')
    );

    var desktopMenuItems = Array.prototype.slice.call(
      document.querySelectorAll('.site-header .navbar-collapse .navbar-nav > li')
    );

    desktopMenuItems.forEach(function (menuItem) {
      menuItem.addEventListener('mouseenter', function () {
        var focusedElement = document.activeElement;

        // A clicked link must not keep a sibling dropdown open via :focus-within.
        if (focusedElement && !menuItem.contains(focusedElement) &&
            menuItem.parentElement.contains(focusedElement) &&
            typeof focusedElement.blur === 'function') {
          focusedElement.blur();
        }
      });
    });

    desktopMenuParentLinks.forEach(function (parentLink) {
      parentLink.setAttribute('role', 'button');
      parentLink.setAttribute('aria-haspopup', 'true');
      parentLink.setAttribute('aria-expanded', 'false');

      parentLink.addEventListener('click', function (event) {
        event.preventDefault();
        parentLink.setAttribute('aria-expanded', 'true');
      });

      parentLink.addEventListener('focus', function () {
        parentLink.setAttribute('aria-expanded', 'true');
      });

      parentLink.addEventListener('blur', function () {
        parentLink.setAttribute('aria-expanded', 'false');
      });

      parentLink.addEventListener('keydown', function (event) {
        if (event.key === ' ') {
          event.preventDefault();
          parentLink.setAttribute('aria-expanded', 'true');
        }
      });
    });

    /*
     * Custom mobile drawer and sliding submenu panels.
     */
    var mobileMenuWrapper = document.querySelector('[data-mobile-menu]');
    var mobileMenuElement = document.querySelector('#my-menu');

    if (mobileMenuWrapper && mobileMenuElement) {
      var mobileMenuToggles = Array.prototype.slice.call(document.querySelectorAll('[data-mobile-menu-toggle]'));
      var mobileMenuBack = mobileMenuElement.querySelector('[data-mobile-menu-back]');
      var mobileMenuSocials = mobileMenuElement.querySelector('.mobile-menu__socials');
      var rootMobileMenuPanel = Array.prototype.slice.call(mobileMenuElement.children).filter(function (child) {
        return child.tagName === 'UL';
      })[0];
      var mobileMenuPanels = rootMobileMenuPanel ? [rootMobileMenuPanel] : [];
      var mobileMenuPanelStack = rootMobileMenuPanel ? [rootMobileMenuPanel] : [];
	  var mobileMenuSubmenuTitle = mobileMenuElement.getAttribute('data-mobile-menu-submenu-title') || 'ПОДМЕНИ';
	  var mobileMenuOpenPrefix = mobileMenuElement.getAttribute('data-mobile-menu-open-prefix') || 'Отвори';

      var setMobileMenuToggleState = function (isOpen) {
        mobileMenuToggles.forEach(function (mobileMenuToggle) {
          var menuIcon = mobileMenuToggle.querySelector('[data-mobile-menu-icon]');
		  var openLabel = mobileMenuToggle.getAttribute('data-mobile-menu-open-label') || 'Отвори мени';
		  var closeLabel = mobileMenuToggle.getAttribute('data-mobile-menu-close-label') || 'Затвори мени';

          mobileMenuToggle.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
		  mobileMenuToggle.setAttribute('aria-label', isOpen ? closeLabel : openLabel);
          mobileMenuToggle.classList.toggle('is-active', isOpen);

          if (menuIcon) {
            menuIcon.classList.toggle('icon-menu', !isOpen);
            menuIcon.classList.toggle('icon-close', isOpen);
          }
        });
      };

      var resetMobileMenuPanels = function () {
        mobileMenuPanels.forEach(function (panel) {
          panel.classList.remove('is-active', 'is-parent');
          panel.scrollTop = 0;
        });

        mobileMenuPanelStack = rootMobileMenuPanel ? [rootMobileMenuPanel] : [];
        mobileMenuElement.classList.remove('is-submenu-open');

        if (rootMobileMenuPanel) {
          rootMobileMenuPanel.classList.add('is-active');
        }
      };

      var openMobileMenuPanel = function (panel) {
        var currentPanel = mobileMenuPanelStack[mobileMenuPanelStack.length - 1];

        if (!panel || panel === currentPanel) {
          return;
        }

        if (currentPanel) {
          currentPanel.classList.remove('is-active');
          currentPanel.classList.add('is-parent');
        }

        panel.classList.remove('is-parent');
        panel.classList.add('is-active');
        panel.scrollTop = 0;
        mobileMenuPanelStack.push(panel);
        mobileMenuElement.classList.add('is-submenu-open');
      };

      var closeMobileMenuPanel = function () {
        if (mobileMenuPanelStack.length <= 1) {
          return;
        }

        var currentPanel = mobileMenuPanelStack.pop();
        var parentPanel = mobileMenuPanelStack[mobileMenuPanelStack.length - 1];

        currentPanel.classList.remove('is-active');
        parentPanel.classList.remove('is-parent');
        parentPanel.classList.add('is-active');

        if (mobileMenuPanelStack.length === 1) {
          mobileMenuElement.classList.remove('is-submenu-open');
        }
      };

      var openMobileMenu = function () {
        resetMobileMenuPanels();

		if (typeof closeHeaderSearch === 'function') {
		  closeHeaderSearch();
		}

        mobileMenuWrapper.classList.add('is-open');
        mobileMenuWrapper.setAttribute('aria-hidden', 'false');
        document.body.classList.add('mobile-menu-open');
        setMobileMenuToggleState(true);
      };

      var closeMobileMenu = function (restoreFocus) {
        mobileMenuWrapper.classList.remove('is-open');
        mobileMenuWrapper.setAttribute('aria-hidden', 'true');
        document.body.classList.remove('mobile-menu-open');
        setMobileMenuToggleState(false);

        if (restoreFocus && mobileMenuToggles[0]) {
          mobileMenuToggles[0].focus();
        }
      };

      if (rootMobileMenuPanel) {
        rootMobileMenuPanel.classList.add('mobile-menu__panel', 'mobile-menu__panel--root', 'is-active');

        Array.prototype.slice.call(rootMobileMenuPanel.querySelectorAll('.sub-menu')).forEach(function (submenu) {
          var parentItem = submenu.parentElement;
          var parentLink = Array.prototype.slice.call(parentItem.children).filter(function (child) {
            return child.tagName === 'A';
          })[0];
		  var submenuTitle = parentLink ? parentLink.textContent.trim() : mobileMenuSubmenuTitle;
          var submenuToggle = document.createElement('button');
          var submenuTarget = submenu;

          if (parentItem.parentElement === rootMobileMenuPanel) {
            var directColumns = Array.prototype.slice.call(submenu.children).filter(function (child) {
              return child.tagName === 'LI';
            });

            if (directColumns.length === 1) {
              var singleColumnSubmenu = Array.prototype.slice.call(directColumns[0].children).filter(function (child) {
                return child.tagName === 'UL' && child.classList.contains('sub-menu');
              })[0];

              if (singleColumnSubmenu) {
                submenuTarget = singleColumnSubmenu;
              }
            }
          }

          submenu.classList.add('mobile-menu__panel');
          submenu.setAttribute('data-mobile-menu-title', submenuTitle.toLocaleUpperCase('sr'));
          mobileMenuPanels.push(submenu);

          submenuToggle.type = 'button';
          submenuToggle.className = 'mobile-menu__submenu-toggle';
		  submenuToggle.setAttribute('aria-label', mobileMenuOpenPrefix + ' ' + submenuTitle);
          submenuToggle.innerHTML = '<i class="icon-angle-right" aria-hidden="true"></i>';
          parentItem.insertBefore(submenuToggle, submenu);

          submenuToggle.addEventListener('click', function (event) {
            event.preventDefault();
            openMobileMenuPanel(submenuTarget);
          });

          if (parentLink) {
			parentLink.setAttribute('aria-haspopup', 'true');

            parentLink.addEventListener('click', function (event) {
              event.preventDefault();
              openMobileMenuPanel(submenuTarget);
            });
          }

          mobileMenuElement.appendChild(submenu);
        });

		if (mobileMenuSocials) {
		  var mobileMenuSocialItem = document.createElement('li');
		  mobileMenuSocialItem.className = 'mobile-menu__social-item';
		  mobileMenuSocialItem.appendChild(mobileMenuSocials);
		  rootMobileMenuPanel.appendChild(mobileMenuSocialItem);
		}
      }

      mobileMenuToggles.forEach(function (mobileMenuToggle) {
        mobileMenuToggle.addEventListener('click', function (event) {
          event.preventDefault();

          if (mobileMenuWrapper.classList.contains('is-open')) {
            closeMobileMenu(false);
          } else {
            openMobileMenu();
          }
        });
      });

      if (mobileMenuBack) {
        mobileMenuBack.addEventListener('click', function (event) {
          event.preventDefault();
          closeMobileMenuPanel();
        });
      }

      document.addEventListener('keydown', function (event) {
        if (event.key === 'Escape' && mobileMenuWrapper.classList.contains('is-open')) {
          closeMobileMenu(true);
        }
      });

      window.addEventListener('resize', function () {
        if (window.innerWidth > 1024 && mobileMenuWrapper.classList.contains('is-open')) {
          closeMobileMenu(false);
        }
      });

      setMobileMenuToggleState(false);
    }

  });
})(jQuery);
